import { Icon } from '@vilibets/vilibets-uikit/dist/atoms/Icon';
import { InfoCircle } from '@vilibets/vilibets-uikit/dist/atoms/Icons';
import { SectionTopMenu } from '@vilibets/vilibets-uikit/dist/molecules/SectionTopMenu/SectionTopMenu';
import { CalculatorsWizard } from '@vilibets/vilibets-uikit/dist/molecules/Wizards/Wizards';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import updateUser from '../../services/users';

const Calculators = ({ children }) => {
  const [showWizard, setShowWizard] = useState(false);

  const {
    dispatchUser,
    state: { user },
  } = useUser();

  const links = [
    '/calculators/normal',
    '/calculators/dutching',
    '/calculators/risk-free',
    '/calculators/accumulated',
    '/calculators/ff-refound',
    '/calculators/triple-refound',
    '/calculators/ff-accumulated',
    // Al final a propósito: `changeStep` hace links[step - 1] y el orden es load-bearing
    // para el wizard. La Dutching Cashback no forma parte del tour (decisión 18).
    '/calculators/dutching-cashback',
    // Y la Dutching 2FBs tampoco: mismo criterio, y va después por la misma razón.
    '/calculators/dutching-2fbs',
  ];
  const navigate = useNavigate();
  const { pathname } = useLocation();

  function changeStep(step) {
    const url = step === 0 ? links[0] : links[step - 1];
    // El wizard llama a changeStep al montarse. Si ya estamos en esa calculadora, navegar a la
    // ruta pelada pisaría el query string y borraría el estado persistido (decisión 19).
    if (url === pathname) return undefined;
    return navigate(url);
  }

  function checkInitWizardStep() {
    // Comparar por substring confundía 'calculators/dutching' con 'calculators/dutching-cashback':
    // el wizard montaba en el paso de la Dutching vieja y su efecto navegaba ahí, borrando el query
    // string. Se compara la ruta exacta, sin barra final.
    const ruta = pathname.replace(/\/+$/, '') || '/';
    const indice = links.indexOf(ruta);
    return indice <= 0 ? 0 : indice + 1;
  }

  const closeWizard = async (show) => {
    setShowWizard(show);
    const response = await updateUser({ ...user, is_showed_wizard_calculator: show });
    dispatchUser({ type: 'hasUser', dispatch: response });
  };

  useEffect(() => {
    if (user) {
      setShowWizard(user?.is_showed_wizard_calculator);
    }
  }, [user]);

  return (
    <div className="flex flex-col mb-24" id="header-menu">
      <CalculatorsWizard
        display={showWizard}
        closePopup={() => {
          closeWizard(false);
        }}
        changeStep={(step) => changeStep(step)}
        initialWizardStep={checkInitWizardStep()}
      />
      <SectionTopMenu
        openInNewTab={true}
        links={[
          {
            title: 'Normal',
            link: '/calculators/normal',
          },
          {
            title: 'Dutching',
            link: '/calculators/dutching',
          },
          {
            title: 'Sin Riesgo Reembolso',
            link: '/calculators/risk-free',
          },
          {
            title: 'Acumuladas',
            link: '/calculators/accumulated',
          },
          {
            title: 'F-F Reembolso',
            link: '/calculators/ff-refound',
          },
          {
            title: '3-F Reembolso',
            link: '/calculators/triple-refound',
          },
          {
            title: 'Acumuladas F-F',
            link: '/calculators/ff-accumulated',
          },
          {
            title: 'Dutching Cashback',
            link: '/calculators/dutching-cashback',
          },
          {
            title: 'Dutching 2FBs',
            link: '/calculators/dutching-2fbs',
          },
        ]}
      />
      <section className="flex justify-end">
        <Icon
          className="stroke-black-7 text-xl mr-2"
          onClick={() => {
            closeWizard(true);
          }}>
          <InfoCircle />
        </Icon>
      </section>

      <section className="items-center">{children}</section>
    </div>
  );
};

export default Calculators;
